import { render, staticRenderFns } from "./CouponBox.vue?vue&type=template&id=48aca2e5&scoped=true&"
import script from "./CouponBox.vue?vue&type=script&lang=js&"
export * from "./CouponBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aca2e5",
  null
  
)

export default component.exports